import update, { extend } from "immutability-helper";

extend("$autoArray", (value, object = []) => update(object, value));

export { update, extend };
